import { SelectOption } from '@tryhackme/thm-ui-components';

export const SORT_BY: SelectOption[] = [
  { id: '1', label: 'Newest', value: 'Newest' },
  { id: '2', label: 'Oldest', value: 'Oldest' },
  { id: '3', label: 'A-Z', value: 'A-Z' },
  { id: '4', label: 'Z-A', value: 'Z-A' },
];
